import React, { useEffect, useState } from 'react';
import {
  Container,
  Content,
  Header,
  Title,
  CloseButton,
  CloseIcon,
  Body,
} from './style';
import { useModal, useHideModal } from '../../hooks';

export default () => {
  const { blured: modal } = useModal();
  const { hideModal } = useHideModal();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (modal.show) {
      setIsOpen(true);
    }
  }, [modal.show]);

  const handleCloseModal = () => {
    setTimeout(() => {
      hideModal();
    }, 300);
    setIsOpen(false);
  };

  return (
    <Container show={modal.show}>
      <Content
        maxWidth={modal.maxWidth}
        show={isOpen}
        overflow={modal?.overflow}
      >
        <Header>
          <Title className='noselect'>{modal.title || ''}</Title>
          <CloseButton onClick={handleCloseModal}>
            <CloseIcon />
          </CloseButton>
        </Header>
        <Body maxHeight={modal.maxHeight} overflow={modal.overflow}>
          {(modal.body && <modal.body />) || 'Body'}
        </Body>
      </Content>
    </Container>
  );
};
